//设置API地址
export const setApiHost = (host1, host2) => {
  window.ApiHost1 = host1 ? host1 : window.ApiHost1;
  window.ApiHost2 = host2 ? host2 : window.ApiHost2;
  console.log('--设置API IP--', window.ApiHost1, window.ApiHost2);
}
//初始化页面
export const initPage = (self) => {
  console.log('---initPage---');
  if(window.location.host.indexOf('.178') != -1 || window.location.host.indexOf('127.0.0.1') != -1 || window.location.host.indexOf('localhost') != -1) {
    let localUrl = window.location.protocol + '//' + window.location.host;
    //window.gbfc_getApiHost('http://172.16.69.65/3dwebapi', 'http://192.168.3.71:8083');
    //window.gbfc_getApiHost('http://172.16.69.65/3dwebapi', 'http://172.16.69.65:8083');
    //window.gbfc_getApiHost('http://172.16.22.41/XMPYAPI', 'http://172.16.22.42:8083');
    if(window.location.host.indexOf('.178') != -1) {
      document.getElementsByTagName('html')[0].style.backgroundColor = 'rgba(0, 0, 0, 0)';
    }
  } else {
    document.getElementsByTagName('html')[0].style.backgroundColor = 'rgba(0, 0, 0, 0)';
  }
  //监测服务器地址
  window.timeout = setInterval(function() {
    if(window.ApiHost1) {
      clearInterval(window.timeout);
      if(self.resetData) {
        console.log('---------------window.timeout--------------------')
        self.resetData();
      }
      return;
    }
  }, 1);
}
//格式化时间戳
export const formatDateTime = (inputTime, format) => {
  if (typeof (inputTime) == 'undefined' || !inputTime) {
      var date = new Date();
  } else {
      var date = new Date(inputTime * 1000);
  }
  if (typeof (format) == 'undefined') {
      format = 'yyyy/MM/dd hh:mm:ss';
  }
  var datetime = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "q+": Math.floor((date.getMonth() + 3) / 3),
      "S+": date.getMilliseconds()
  };
  if (/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in datetime) {
      if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
              datetime[k] : ("00" + datetime[k]).substr(("" + datetime[k]).length));
      }
  }
  return format;
};

//前端分页
export const dataPage = (dataList, curPage, pagesize) => {
  let offset = (curPage - 1) * pagesize;//当前页第一条的索引
  let retdata = (offset + pagesize >= dataList.length) ?
                          dataList.slice(offset, dataList.length) :
                          dataList.slice(offset, offset + pagesize);
  return retdata;
}

//处理数值
export const handleNumber = (num) => {
  if(!num) {
    return 0;
  }
  let retnum = 0;
  let zeroup  = true;
  if(typeof(num) != 'number') {
    num = Number(num);
  }
  if(num < 0) {
    num = Math.abs(num);
    zeroup = false;
  }
  //取两位小数
  num = Math.round(num*100) / 100;
  if(num < 100) {
    retnum = num;
  } else if(num < 1000) {
    retnum = Math.round(num * 10) / 10;
  } else if(num < 10000) {
    retnum = (Math.round(num / 10) / 100) + 'k';
  } else if(num < 10000000) {
    retnum = (Math.round(num / 1000) / 10) + 'w';
  } else {
    retnum = (Math.round(num / 100000) / 100) + 'kw';
  }
  return zeroup ? retnum : '-' + retnum;
}



// WEBPACK FOOTER //
// ./src/utils/functions.js